export default __webpack_public_path__ + "static/media/icon_organizationsubcription.825bc96d.svg";